module.exports = require("core-js-pure/stable/object/values");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/values.js
// module id = 6453
// module chunks = 25